<section *ngIf="myself" class="user-settings-details-wrapper" [attr.aria-labelledby]="'details-heading'">
  <app-cr-header id="details-heading" [headingLevel]="2">
    {{ 'USER_SETTINGS.USER_SETTINGS_DETAILS' | translate }}
  </app-cr-header>

  <div class="form-container">
    <!-- Avatar -->
    <div class="spinner-container">
      <nz-spin [nzSpinning]="loading$ | async" [attr.aria-busy]="loading$ | async">
        <app-cr-avatar
          *ngIf="userName"
          [userName]="userName"
          [theme]="'THEME-2'"
          [size]="'L'"
          [attr.aria-hidden]="true"></app-cr-avatar>
      </nz-spin>
    </div>

    <p id="details-form-description" class="sr-only" [attr.aria-hidden]="true">
      {{ 'USER_SETTINGS.USER_SETTINGS_DETAILS_DESCRIPTION' | translate }}
    </p>

    <form nz-form [formGroup]="form" [attr.aria-describedby]="'details-form-description'">
      <!-- USERNAME -->
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="24" nzRequired nzFor="name">
          {{ 'COMMON.LABEL.USERNAME' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="24"
          nzHasFeedback
          [nzValidateStatus]="form.controls.name"
          [nzErrorTip]="nameErrorTpl">
          <input
            nz-input
            id="name"
            type="text"
            formControlName="name"
            required
            [attr.aria-invalid]="form.controls.name.invalid && form.controls.name.touched"
            [attr.aria-describedby]="form.controls.name.invalid && form.controls.name.touched ? 'nameError' : null" />
        </nz-form-control>

        <!-- ERROR -->
        <ng-template #nameErrorTpl>
          <mat-error id="nameError">
            {{ form.controls.name.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </ng-template>
      </nz-form-item>

      <!-- LANGUAGE -->
      <nz-form-item *ngIf="languages$ | async as languages">
        <nz-form-label id="languageLabel" [nzSm]="12" [nzXs]="24" nzRequired nzFor="language">
          {{ 'COMMON.LANGUAGE.LAYOUT_LANGUAGE' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="24"
          nzHasFeedback
          [nzValidateStatus]="form.controls.languageId"
          [nzErrorTip]="languageErrorTpl">
          <nz-select
            id="language"
            formControlName="languageId"
            [nzPlaceHolder]="'COMMON.LANGUAGE.LAYOUT_LANGUAGE' | translate"
            [required]="true"
            [nzShowSearch]="false"
            [attr.aria-labelledby]="'languageLabel'"
            [attr.aria-invalid]="form.controls.languageId.invalid && form.controls.languageId.touched ? 'true' : null"
            [attr.aria-describedby]="
              form.controls.languageId.invalid && form.controls.languageId.touched ? 'languageError' : null
            ">
            <nz-option
              *ngFor="let lang of languages"
              [nzValue]="lang.id"
              [nzLabel]="'COMMON.LANGUAGE.' + lang.key.toUpperCase() | translate">
            </nz-option>
          </nz-select>
        </nz-form-control>

        <!-- ERROR -->
        <ng-template #languageErrorTpl>
          <mat-error id="languageError">
            {{ form.controls.languageId.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </ng-template>
      </nz-form-item>

      <!-- EMAIL -->
      <nz-form-item *ngIf="myself?.role?.key !== 'FOREIGNER'">
        <nz-form-label [nzSm]="12" [nzXs]="24" nzRequired nzFor="email">
          {{ 'COMMON.LABEL.EMAIL' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="24"
          nzHasFeedback
          [nzValidateStatus]="form.controls.email"
          [nzErrorTip]="emailErrorTpl">
          <input
            nz-input
            id="email"
            type="text"
            formControlName="email"
            required
            [attr.aria-invalid]="form.controls.email.invalid && form.controls.email.touched"
            [attr.aria-describedby]="
              form.controls.email.invalid && form.controls.email.touched ? 'emailError' : null
            " />
        </nz-form-control>

        <!-- ERROR -->
        <ng-template #emailErrorTpl>
          <mat-error id="emailError">
            {{ form.controls.email.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </ng-template>
      </nz-form-item>

      <!-- PHONE NUMBER -->
      <nz-form-item>
        <nz-form-label [nzSm]="12" [nzXs]="24" nzRequired nzFor="telephoneNumber">
          {{ 'COMMON.LABEL.PHONE_NUMBER' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="24"
          nzHasFeedback
          [nzValidateStatus]="form.controls.telephoneNumber"
          [nzErrorTip]="telephoneNumberErrorTpl">
          <input
            nz-input
            id="telephoneNumber"
            type="text"
            formControlName="telephoneNumber"
            required
            [attr.aria-invalid]="form.controls.telephoneNumber.invalid && form.controls.telephoneNumber.touched"
            [attr.aria-describedby]="
              form.controls.telephoneNumber.invalid && form.controls.telephoneNumber.touched
                ? 'telephoneNumberError'
                : null
            " />
        </nz-form-control>

        <!-- ERROR -->
        <ng-template #telephoneNumberErrorTpl>
          <mat-error id="telephoneNumberError">
            {{ form.controls.telephoneNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </ng-template>
      </nz-form-item>

      <!-- OFFICE -->
      <nz-form-item *ngIf="shouldShowOfficeField && (offices$ | async)?.length">
        <nz-form-label [nzSm]="12" [nzXs]="24" nzRequired nzFor="officeId">
          {{ 'COMMON.LABEL.ASSIGNED_OFFICE' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzSm]="12"
          [nzXs]="24"
          nzHasFeedback
          [nzValidateStatus]="form.controls.officeId"
          [nzErrorTip]="officeIdErrorTpl">
          <nz-select
            *ngIf="shouldShowOfficeField && (offices$ | async)?.length"
            id="officeId"
            formControlName="officeId"
            [nzPlaceHolder]="'COMMON.LABEL.ASSIGNED_OFFICE' | translate"
            [required]="true"
            [attr.aria-invalid]="form.controls.officeId.invalid && form.controls.officeId.touched"
            [attr.aria-describedby]="
              form.controls.officeId.invalid && form.controls.officeId.touched ? 'officeIdError' : null
            ">
            <nz-option
              *ngFor="let office of offices$ | async"
              [nzValue]="office.id"
              [nzLabel]="office.addressCity + ' (' + office.addressStreet + ')'">
            </nz-option>
          </nz-select>
        </nz-form-control>

        <!-- ERROR -->
        <ng-template #officeIdErrorTpl>
          <mat-error id="officeIdError">
            {{ form.controls.officeId.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </ng-template>
      </nz-form-item>

      <div class="form-column submit-column">
        <button
          class="submit-button submit"
          type="submit"
          (click)="submitProfileForm()"
          nz-button
          nzType="primary"
          [nzLoading]="loading$ | async"
          [disabled]="(form.dirty && form.invalid) || form.pristine">
          {{ 'COMMON.ACTION.UPDATE' | translate }}
        </button>
        <button
          class="submit-button"
          type="button"
          (click)="exitUserSettings()"
          nz-button
          nzType="default"
          [nzLoading]="loading$ | async">
          {{ 'USER_SETTINGS.EXIT_SETTINGS' | translate }}
        </button>
        <button
          class="submit-button remove"
          type="button"
          (click)="deleteAccount()"
          nz-button
          nzType="primary"
          nzDanger
          [nzLoading]="loading$ | async">
          {{ 'COMMON.ACTION.REMOVE_ACCOUNT' | translate }}
        </button>
      </div>
    </form>
  </div>
</section>
